import styled from '@emotion/styled'

import { palette, spacing } from 'main/ui'

export const Container = styled.div`
  align-items: center;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  margin-right: ${spacing.majorScale(2)}px;

  > :not(:last-child) {
    margin-right: ${spacing.majorScale(1)}px;
  }
`

export const CaretIconContainer = styled.div`
  color: ${palette.mediumGray};
  width: 12px;
`

export const Avatar = styled.img`
  border-radius: 50%;
  height: 32px;
  width: 32px;
`
